<script setup lang="ts">
/**
 * SettingsState — HLOS-227 + Fases 0/5 Lume.
 *
 * Renderiza:
 * - <AIDisclosureNotice> (HLOS-225, disclosure UX)
 * - <AccessibilitySettings> (Fase 0, F1-F6)
 * - <CompanionIdentitySettings> (Fase 5, L1+L3)
 *
 * Constitucional: ver cada componente importado.
 */

import { AIDisclosureNotice } from "../onboarding";
import AccessibilitySettings from "../accessibility/components/AccessibilitySettings.vue";
import CompanionIdentitySettings from "../companion-identity/components/CompanionIdentitySettings.vue";

interface Emits {
  (e: "close"): void;
}

const emit = defineEmits<Emits>();

function onClose(): void {
  emit("close");
}
</script>

<template>
  <section
    class="hlos-settings"
    data-testid="settings-state"
    data-state="settings"
  >
    <header class="hlos-settings__header">
      <h2>Configurações</h2>
    </header>

    <AIDisclosureNotice
      scope="settings"
      :collapsed="false"
      :dismissible="false"
      data-testid="settings-disclosure"
    />

    <hr class="hlos-settings__divider" aria-hidden="true" />

    <AccessibilitySettings @close="onClose" />

    <hr class="hlos-settings__divider" aria-hidden="true" />

    <CompanionIdentitySettings @close="onClose" />

    <div class="hlos-settings__actions">
      <button
        type="button"
        data-testid="settings-close"
        class="hlos-settings__close"
        @click="onClose"
      >
        Voltar
      </button>
    </div>
  </section>
</template>

<style scoped>
.hlos-settings {
  max-width: 720px;
  margin: 0 auto;
  padding: 1.5rem;
}
.hlos-settings__header {
  margin-bottom: 1rem;
}
.hlos-settings__header h2 {
  margin: 0;
  font-size: 1.25rem;
}
.hlos-settings__divider {
  border: none;
  border-top: 1px solid var(--hlos-color-neutral-200);
  margin: 1.5rem 0;
}
.hlos-settings__actions {
  margin-top: 1.5rem;
}
.hlos-settings__close {
  font: inherit;
  padding: 0.5rem 1rem;
  border: 1px solid currentColor;
  border-radius: 0.375rem;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.hlos-settings__close:hover:not(:disabled) {
  background: color-mix(in srgb, currentColor 10%, transparent);
}
</style>
